import React, { useEffect, useState } from "react";
import {
  Pagination,
  Stack,
  Button,
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Skeleton,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  IconButton,
} from "@mui/material";
import { toast } from "react-toastify";
import "../SupervisorContact/supervisor.css";
import { RiErrorWarningLine } from "react-icons/ri";
import axios from "axios";
import {
  BaseUrl,
  excelDownloadUrl,
  VoiceDomainName,
  VoiceDomainNamePure
} from "../../container/BaseUrl/BaseUrl";
import moment from "moment";
import {
  DownloadSimple,
  PhoneOutgoing,
  Upload,
  WarningCircle,
} from "@phosphor-icons/react";
import { connect } from "react-redux";
import { setDialedNumberInc } from "../../redux/actions/actions";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const mapStateToProps = (state) => {
  return {
    skillset: state.data.skillset,
    showingStatusVoice: state.contactListData.showingStatusVoice,
  };
};

const Campaign = (props) => {
  const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const isToDateValid = () => {
    return new Date(todate) >= new Date(fromdate);
  };

  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [showfilter, setshowfilter] = useState(false);

  const [UploadDialogBox, setUploadDialogBox] = useState(false);
  const [UploadButton, setUploadButton] = useState(true);
  const [SupervisorCampaignList, setSupervisorCampaignList] = useState([]);
  const [agentCampaignList, setAgentCampaignList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [SupervisorAgentName, setSupervisorAgentName] = useState([]);
  const [fileuploadPopup, setfileuploadPopup] = useState(false);
  const [ListOfAgent, setListOfAgent] = useState([]);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [spinner, setspinner] = useState(false);

  const [selectedfile, setSelectedfile] = useState(false);

  const handleClose = () => {
    setUploadDialogBox(false);
  };
  const hiddenFileInput = React.useRef(null);
  const handleClosePreview = () => {
    if (hiddenFileInput.current) {
      hiddenFileInput.current.value = "";
    }
  };

  const handleConfirmUploadPreview = (event) => {
    const dataFile = event.target.files[0];
    setSelectedfile(dataFile);
    if (selectedAgents.length > 0 && dataFile) {
      setUploadButton(false);
    } else {
      setUploadButton(true);
    }
  };

  const SaleshandleChangeFile = async (file) => {
    if (file) {
      let agent = JSON.stringify(selectedAgents);
      console.log("agent", agent);
      const dataArray = new FormData();
      dataArray.append("file", file);
      dataArray.append("agentList", agent);
      setspinner(true);

      await axios
        .post(BaseUrl + "/users/createExcelSheetCampaign", dataArray, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "multipart/form-data",
            tenantId: localStorage.getItem("TenantId"),
          },
        })
        .then(() => {
          setTimeout(() => {
            setspinner(false);
          }, 2000);
          setSelectedfile(null);
          SupervisorListCampaign();
          handleClose();
        })
        .catch((err) => {
          console.log("err", err);
          toast.error("sales excel not uploaded");
          setspinner(false);
          setSelectedfile(null);
          setSelectedAgents(null);
        });
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleChangeAgent = (event) => {
    setSelectedAgents(event.target.value);
    if (selectedfile && event.target.value.length > 0) {
      setUploadButton(false);
    } else {
      setUploadButton(true);
    }
  };

  const UploadhandleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const AgentListCampaign = async () => {
    let data = {
      from_date: fromdate,
      to_date: todate,
      agent_id: loggedInAgent.agent_id,
      offset: page == 1 ? 0 : (page - 1) * 10,
      limit: 10,
    };
    await axios
      .post(BaseUrl + "/contact/listcampaign", data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        console.log("listSalesreport", res);
        if (res.data.status == true) {
          setAgentCampaignList(res.data.data);
          setPagination(res.data.count);
        } else {
          toast.warn("No Data Found", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setAgentCampaignList([]);
          setPagination(0);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setAgentCampaignList([]);
        setPagination(0);
      });
  };
  const SupervisorListCampaign = async () => {
    let body = {
      from_date: fromdate,
      to_date: todate,
      agent_id: loggedInAgent.agent_id,
      offset: page == 1 ? 0 : (page - 1) * 10,
      limit: 10,
    };
    await axios
      .post(BaseUrl + "/contact/listcampaignsupervisor", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.status == true) {
          setSupervisorCampaignList(res.data.data);
          setPagination(res.data.count);
        } else {
          toast.warn("No Data Found", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSupervisorCampaignList([]);
          setPagination(0);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setSupervisorCampaignList([]);
        setPagination(0);
      });
  };
  const AgentList = async () => {
    await axios
      .post(
        BaseUrl + "/users/listagentList",
        {
          user_id: loggedInAgent.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setSupervisorAgentName(res.data.data);
        setListOfAgent(res.data.data);
      })
      .catch((error) => {});
  };
  const makeCall = (calledNo) => {
    let number = localStorage.getItem("TenantId")=='788205e1-6116-4c09-904a-5b641d09de0f'?`${calledNo}`:`9${calledNo}`;
    if (props.showingStatusVoice == "Ready") {
      localStorage.setItem("callActivate", "true");
      localStorage.setItem("CallMadeFromDcc", "true");
      let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
      let avcurlid = localStorage.getItem("AvcUrl");
      props.setDialedNumberInc(number);
      localStorage.setItem("ClickeToCallPhoneNum", number);
      localStorage.setItem("dailedNumber", number);
      localStorage.setItem("ClickToCall", "true");
      axios
        .post(
          avcurlid +
            `/voice/terminal/${agentLoginTerminalId}/createContact/sip:${agentLoginTerminalId}@${localStorage.getItem("TenantId")=='788205e1-6116-4c09-904a-5b641d09de0f'?VoiceDomainNamePure:VoiceDomainName}/sip:${number}@${localStorage.getItem("TenantId")=='788205e1-6116-4c09-904a-5b641d09de0f'?VoiceDomainNamePure:VoiceDomainName}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == "OK") {
          } else {
            toast.warn(res.data.status, {
              position: "top-right",
              autoClose: 500,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
            });
          }
        })
        .catch((err) => {
          console.log("makeCall", err.code == " ERR_BAD_REQUEST");
          if (err.code == "ERR_BAD_REQUEST") {
            toast.error("Please change status to Ready", {
              position: "top-right",
              autoClose: 500,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
            });
          }
        });
    } else {
      toast.error("Please change status to Ready", {
        position: "top-right",
        autoClose: 500,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
      });
    }
  };

  useEffect(() => {
    if (loggedInAgent.role == "Supervisor") {
      SupervisorListCampaign();
    } else {
      AgentListCampaign();
    }
  }, [page]);

  return (
    <>
      <div className="sessiontable">
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <div className="w-100">
            <div className="d-flex align-item-center justify-content-between align-items-center">
              <Stack className="d-flex flex-row gap-1"></Stack>

              {loggedInAgent.role == "Supervisor" ? (
                <Stack className="d-flex flex-row gap-1">
                  <Button
                    size="small"
                    id="sales-primary-btn"
                    variant="contained"
                    onClick={() => {
                      setUploadDialogBox(true);
                      AgentList();
                    }}
                  >
                    Upload
                  </Button>
                  <Button
                    size="small"
                    id="sales-primary-btn"
                    variant="contained"
                    onClick={() => {
                      setshowfilter(true);
                    }}
                  >
                    Filter
                  </Button>
                </Stack>
              ) : (
                <Stack className="d-flex flex-row gap-1">
                  <Button
                    size="small"
                    id="sales-primary-btn"
                    variant="contained"
                    onClick={() => {
                      setshowfilter(true);
                    }}
                  >
                    Filter
                  </Button>
                </Stack>
              )}
            </div>
          </div>
        </nav>

        <div className="container-fluid p-2">
          {loggedInAgent.role == "Supervisor" ? (
            <div className="container-fluid" style={{ paddingLeft: "1px" }}>
              <div className="container-fluid p-2">
                <div className="card fixed-table-card vh-79 ">
                  <div className="card-body agentContactbody">
                    <div className="table-responsive vhm-68">
                      <table className="table table-sm  table-hover align-middle table-fixeded">
                        <thead>
                          <tr>
                            <th scope="col">Agent</th>
                            <th scope="col">Customer Name</th>
                            <th scope="col">Phone Number</th>
                            <th scope="col">Call Status</th>
                            <th scope="col">DNC Status</th>
                            <th scope="col">CustomerID</th>
                            <th scope="col">ContactID</th>
                            <th scope="col">Disposition Code</th>
                            <th scope="col">Retry Count</th>
                            <th scope="col">Retry Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {SupervisorCampaignList.length > 0 ? (
                            SupervisorCampaignList.map((item) => {
                              return (
                                <tr key={item.id}>
                                  <td>{item.agent_id.username}</td>
                                  <td>{item.FirstName}</td>
                                  <td>{item.PhoneNumber}</td>
                                  <td>{item.CallStatus}</td>
                                  <td>{item.DNCStatus}</td>
                                  <td>{item.CustomerID}</td>
                                  <td>{item.ContactID}</td>
                                  <td>{item.DispositionCode}</td>
                                  <td>{item.callcount}</td>
                                  <td>{item.callstatus}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <div
                              className="text-muted"
                              style={{
                                flexDirection: "column",
                                marginTop: "20%",
                                display: "flex",
                                position: "absolute",
                                left: "45%",
                                bottom: "40%",
                              }}
                            >
                              <span className="mx-auto">
                                <WarningCircle size={55} />;
                              </span>
                              <span className="mx-auto">
                                <h5
                                  className="text-muted mt-2"
                                  style={{ fontFamily: "poppins" }}
                                >
                                  No Data Found
                                </h5>
                              </span>
                            </div>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-footer rounded-0 d-flex justify-content-between">
                    <div>
                      Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                      {Math.min(page * 10, pagination)} of {pagination} entries
                    </div>
                    <Pagination
                      count={Math.ceil(pagination / 10)}
                      page={page}
                      color="primary"
                      size="small"
                      style={{ float: "right" }}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="container-fluid" style={{ paddingLeft: "1px" }}>
              <div className="container-fluid p-2">
                <div className="card fixed-table-card vh-79 ">
                  <div className="card-body agentContactbody">
                    <div className="table-responsive vhm-68">
                      <table className="table table-sm  table-hover align-middle table-fixeded">
                        <thead>
                          <tr>
                            <th scope="col">Customer Name</th>
                            <th scope="col">Phone Number</th>
                            <th scope="col">Call Status</th>
                            <th scope="col">DNC Status</th>
                            <th scope="col">CustomerID</th>
                            <th scope="col">ContactID</th>
                            <th scope="col">Disposition Code</th>
                            <th scope="col">Retry Count</th>
                            <th scope="col">Retry Status</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {agentCampaignList.length > 0 ? (
                            agentCampaignList.map((item) => {
                              return (
                                <tr key={item.id}>
                                  <td>{item.FirstName}</td>
                                  <td>{item.PhoneNumber}</td>
                                  <td>{item.CallStatus}</td>
                                  <td>{item.DNCStatus}</td>
                                  <td>{item.CustomerID}</td>
                                  <td>{item.ContactID}</td>
                                  <td>{item.DispositionCode}</td>
                                  <td>{item.callcount}</td>
                                  <td>{item.callstatus}</td>
                                  <td>
                                    <IconButton
                                      onClick={async () => {
                                        await localStorage.setItem(
                                          "CampaignCallClicktoCall",
                                          item.id
                                        );
                                        await localStorage.setItem(
                                          "CampaignCallClicktoCallName",
                                          item.FirstName
                                        );
                                        makeCall(item.PhoneNumber);
                                      }}
                                    >
                                      <PhoneOutgoing size={22} weight="bold" />
                                    </IconButton>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <div
                              className="text-muted"
                              style={{
                                flexDirection: "column",
                                marginTop: "20%",
                                display: "flex",
                                position: "absolute",
                                left: "45%",
                                bottom: "40%",
                              }}
                            >
                              <span className="mx-auto">
                                <WarningCircle size={55} />;
                              </span>
                              <span className="mx-auto">
                                <h5
                                  className="text-muted mt-2"
                                  style={{ fontFamily: "poppins" }}
                                >
                                  No Data Found
                                </h5>
                              </span>
                            </div>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-footer rounded-0 d-flex justify-content-between">
                    <div>
                      Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                      {Math.min(page * 10, pagination)} of {pagination} entries
                    </div>
                    <Pagination
                      count={Math.ceil(pagination / 10)}
                      page={page}
                      color="primary"
                      size="small"
                      style={{ float: "right" }}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {showfilter && (
          <nav className="sidebar_filter active-r" style={{ top: "0px" }}>
            <div className="filter col-md-12 shadow p-4 ">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <p className="mb-0">Filters</p>
                <div className="dismiss ">
                  <span
                    id="session_filter_close_btn"
                    className="material-symbols-outlined"
                    onClick={() => {
                      setshowfilter(false);
                    }}
                  >
                    cancel
                  </span>
                </div>
              </div>

              <div className="filter_form">
                <form className=" fillter_form2 " style={{ height: "75vh" }}>
                  <div className="custom_div">
                    <div className="mb-3 d-flex flex-column text-start">
                      <label htmlFor="fromdate" className="form-label">
                        From
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id=""
                        aria-describedby="date"
                        value={fromdate}
                        onChange={(e) => setFromdate(e.target.value)}
                        max={defaultValue}
                      />
                    </div>
                    <div className="mb-3 d-flex flex-column text-start">
                      <label htmlFor="todate" className="form-label">
                        To
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id=""
                        aria-describedby="date"
                        value={todate}
                        onChange={(e) => setTodate(e.target.value)}
                        max={defaultValue}
                      />
                      {!isToDateValid() && (
                        <span
                          className="text-danger fw-bold"
                          style={{ fontSize: "10px" }}
                        >
                          To Date cannot be less than From Date*
                        </span>
                      )}
                    </div>
                  </div>
                </form>

                <div className="filter_submit">
                  <div className="d-flex">
                    <div className="col-md-12 ps-2">
                      <button
                        type="button"
                        id="session_filter_Submit"
                        className="btn btn-primary w-100 text-white"
                        onClick={() => {
                          if (isToDateValid()) {
                            if (loggedInAgent.role == "Supervisor") {
                              SupervisorListCampaign();
                            } else {
                              AgentListCampaign();
                            }
                            setPage(1);
                            setshowfilter(false);
                          }
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        )}
      </div>

      <Dialog
        open={UploadDialogBox}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .MuiPaper-root": {
            borderRadius: 5,
            padding: 1,
            top: -100,
          },

          backgroundColor: "rgb(0 0 0 / 65%)",
        }}
      >
        <DialogTitle
          variant="subtitle2"
          sx={{ fontSize: "16px", fontWeight: 600 }}
        >
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <Button
              variant="contained"
              id="file-btn"
              size="small"
              endIcon={<DownloadSimple size={15} />}
              onClick={() => {
                UploadhandleClick();
              }}
            >
              Choose file
              <input
                type="file"
                ref={hiddenFileInput}
                onChange={(event) => {
                  handleConfirmUploadPreview(event);
                }}
                style={{ display: "none" }}
              />
            </Button>

            <Box sx={{ width: "320px" }}>
              <FormControl sx={{ m: 1, width: 300 }} size="small">
                <InputLabel id="demo-multiple-name-label">
                  Select Agent
                </InputLabel>
                <Select
                  labelId="demo-multiple-name-label"
                  id="demo-multiple-name"
                  multiple
                  value={selectedAgents} // Make sure selectedAgents is an array
                  onChange={handleChangeAgent} // Provide a function to handle changes
                  input={<OutlinedInput label="Select Agent" />}
                  MenuProps={{
                    style: {
                      top: "0px",
                      maxHeight: "350px",
                    },
                  }}
                >
                  {ListOfAgent.length > 0 ? (
                    ListOfAgent.map((Agent) => (
                      <MenuItem value={Agent.id} key={Agent.id}>
                        {Agent.username}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>{"No Data"}</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Box>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Stack spacing={0.5} sx={{ height: "40px", width: "450px" }}>
              <label
                htmlFor="formFileSm"
                className="form-label col-form-label-sm"
              >
                <div style={{ fontSize: "12px" }}>
                  {selectedfile ? selectedfile.name : ""}
                </div>

                <p>
                  Please Download Sample Sheet{" "}
                  <a href={excelDownloadUrl + "/uploads/campaignexcel.xlsx"}>
                    Link
                  </a>{" "}
                  Here
                </p>
              </label>
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {spinner ? (
            <span
              className="spinner-border spinner-border-sm text-primary"
              role="status"
              aria-hidden="true"
              style={{
                flexDirection: "column",
                marginTop: "20%",
                display: "flex",
                position: "absolute",
                left: "45%",
                bottom: "30%",
              }}
            ></span>
          ) : (
            <Button
              variant="contained"
              id="upload-primary-btn"
              size="small"
              endIcon={<Upload size={15} />}
              onClick={() => {
                if (selectedfile) {
                  SaleshandleChangeFile(selectedfile);
                }
              }}
              disabled={UploadButton}
            >
              Upload
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default connect(mapStateToProps, { setDialedNumberInc })(Campaign);
